import {
  GET_ORGANIZERS_ERROR,
  GET_ORGANIZERS_LOCATIONS_ERROR,
  GET_ORGANIZERS,
  GET_ORGANIZERS_SUCCESS,
  GET_ORGANIZER_INFO,
  GET_ORGANIZER_INFO_SUCCESS,
  GET_ORGANIZER_INFO_FAILURE,
  GET_OWNER_CLUB,
  GET_OWNER_CLUB_SUCCESS,
  GET_TOURNAMENTS,
  GET_TOURNAMENTS_SUCCESS,
  GET_TOURNAMENTS_FAILURE,
  API_ERROR,
  GET_ORGANIZERS_LOCATIONS,
  GET_ORGANIZERS_LOCATIONS_SUCCESS,
} from "./actionTypes"

export const getOrganizersLocationsSuccess = data => {
  return {
    type: GET_ORGANIZERS_LOCATIONS_SUCCESS,
    payload: data,
  }
}

export const getOrganizersLocations = filters => {
  return {
    type: GET_ORGANIZERS_LOCATIONS,
    payload: filters,
  }
}

export const getOrganizerInfo = id => {
  return {
    type: GET_ORGANIZER_INFO,
    id,
  }
}

export const getOrganizerInfoSuccess = (accountInfo, profileId) => {
  return {
    type: GET_ORGANIZER_INFO_SUCCESS,
    payload: accountInfo,
    profileId,
  }
}

export const getOrganizerInfoFailure = (error, profileId) => ({
  type: GET_ORGANIZER_INFO_FAILURE,
  payload: { status: error?.response?.status || null },
  profileId,
})

export const getOrganizers = (filters, options) => {
  return {
    type: GET_ORGANIZERS,
    filters,
    options,
    payload: [],
  }
}

export const getOrganizersSuccess = accounts => {
  return {
    type: GET_ORGANIZERS_SUCCESS,
    payload: accounts,
  }
}

export const getOwnerClub = id => {
  return {
    type: GET_OWNER_CLUB,
    id,
  }
}

export const getOwnerClubSuccess = ownerClub => {
  return {
    type: GET_OWNER_CLUB_SUCCESS,
    payload: ownerClub,
  }
}

export const getTournaments = (id, options) => {
  return {
    type: GET_TOURNAMENTS,
    id,
    options,
  }
}

export const getTournamentsSuccess = (tournaments, profileId) => {
  return {
    type: GET_TOURNAMENTS_SUCCESS,
    payload: tournaments,
    profileId,
  }
}

export const getTournamentsFailure = profileId => ({ type: GET_TOURNAMENTS_FAILURE, profileId })

export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}

export const getOrganizersError = () => ({ type: GET_ORGANIZERS_ERROR })
export const getOrganizersLocationsError = () => ({ type: GET_ORGANIZERS_LOCATIONS_ERROR })
